module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"description_with_reward":"针对以下关键词撰写评价，经AI分析后将发放额外奖励。","description_wihout_reward":"请尝试针对以下关键词进行撰写。"}}')
  delete Component.options._Ctor
}
